import { cx } from '@twind/core';

import { FormItemImage } from '../types';

interface ContactFormImageProps {
  item: FormItemImage;
}

export function ContactFormImage({ item }: ContactFormImageProps) {
  const { url, link_url, alignment = 'left', scale = 100, alt_text } = item;

  const alignmentClass = {
    left: 'justify-start',
    center: 'justify-center',
    right: 'justify-end',
  }[alignment];

  const containerStyle = {
    maxWidth: `${scale}%`,
    height: 'auto',
  };

  const imageElement = (
    <img
      src={url}
      alt={alt_text || 'Contact form image'}
      className="shadow-sm max-w-full h-auto"
      loading="lazy"
    />
  );

  const content = link_url ? (
    <a
      href={link_url}
      target="_blank"
      rel="noopener noreferrer"
      className="inline-block"
      style={containerStyle}
    >
      {imageElement}
    </a>
  ) : (
    <div
      style={containerStyle}
      className="inline-block"
    >
      {imageElement}
    </div>
  );

  return (
    <>
      <input
        type="hidden"
        name={item.ref_id}
        value="true"
      />
      <div
        className={cx('flex w-full mb-4', alignmentClass)}
        tabIndex={0}
      >
        {content}
      </div>
    </>
  );
}
